const STATUS_CODES = {
  LOADING: 0,
  OK: 200,
  NO_CONTENT: 204,
  ERROR: 500
}

export default STATUS_CODES
